import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-12 text-center">
          <h1 className="display-4">Welcome to Our Application!</h1>
        </div>
      </div>
    </div>
  );
};

export default HomePage;